<div [id]="fieldTitleAnchorId" class="form-step-field-title">
	<tec-form-group
		[label]="fieldTitleLabel"
		[description]="'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELD_TITLE_HINT' | translate"
		[errorMsg]="fieldTitleErrorMessage()"
	>
		<tec-input
			[formControl]="titleControl"
			[placeholder]="'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELD_TITLE_PLACEHOLDER' | translate"
			[hasError]="fieldTitleHasError()"
		></tec-input>
	</tec-form-group>
</div>
